import React, { Component } from 'react';
import { Button, Grid, Icon, Popup } from 'semantic-ui-react';
import { source } from 'react-aim';
import { dispatch } from '@rematch/core';
import { toastr } from 'react-redux-toastr';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Accordion from '@zippytech/react-toolkit/Accordion'
import '@zippytech/react-toolkit/Accordion/index.css'
import Labels from '../../../common/Labels';
import momentDateAndTime from '../../../../helpers/momentDateAndTime';
import camelCaseCovert from '../../../../helpers/convert-camel-case'

@source({
    mouseEnter: (props, component) => dispatch.app.setHelpContext("Community User Invite Resource Pane")
})

class InviteResourcePane extends Component {

    constructor(props) {
        super(props);
        this.convertDate = this.convertDate.bind(this);

    }

    convertDate(payload) {
        let ts = new Date(payload);
        return ts.toDateString()
    }


    render() {
        const inviteLink = `${window.location.origin}/invite/${this.props.inviteUserList._id}`;
         let user=this.props.usersList
         let Name = user.find(obj => obj._id === this.props.inviteUserList.from);
         let invited=Name && Name.firstName+" "+Name.lastName
      
        const expandTool = <div className="plusMinusIcons">
            <Icon className="close" name="plus circle" />
            <Icon className="open" name="minus circle" />
        </div>
        return (
            <div className="accordianBox w_100">
                <div className="accordianPanel w_100">
                    <Accordion expandTool={expandTool} horizontal enableKeyboardNavigation={false}>
                        <div tabTitle="Summary">
                            <div className="acc-header">Summary</div>
                            <Grid >
                                <Grid.Row className="pad_0">
                                    <Grid.Column width={16} >
                                        <Labels
                                            name="Name"
                                            text={`${this.props.inviteUserList.firstName} ${this.props.inviteUserList.lastName}`} />
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row className="pad_0">
                                    <Grid.Column width={10}>
                                        <Labels
                                            name="Email"
                                            text={this.props.inviteUserList.email} />
                                    </Grid.Column>
                                    <Grid.Column width={6}>
                                        <Labels
                                            name="Role"
                                            text={camelCaseCovert(this.props.inviteUserList.role)} />
                                    </Grid.Column>
                                </Grid.Row>
                                {this.props.selectedOrganisation && this.props.selectedOrganisation.role === 'workspaceOwner' ?
                                    <Grid.Row className="pad_0">
                                        <Grid.Column width={10} >
                                            <Labels
                                                name="Invitation Link"
                                                text={<CopyToClipboard text={inviteLink}
                                                    onCopy={() => toastr.success('Message', 'Invitation link is copied to clipboard')}>
                                                    <span>{inviteLink}</span>
                                                </CopyToClipboard>} />
                                            <div className="clr-orange">Invitation sent on &nbsp;
                                        {momentDateAndTime(this.props.inviteUserList.updatedAt)}
                                            </div>
                                        </Grid.Column>
                                        <Grid.Column width={6}>
                                            <Labels
                                            name="Invited By"
                                            text={invited} />
                                    </Grid.Column>
                                    </Grid.Row>
                                    : ''}
                            </Grid>
                        </div>
                    </Accordion>
                </div>

            </div>

        )
    }
}

export default InviteResourcePane;